import React from "react";
import { Compass } from "lucide-react";

const InspirationBand = () => {
  return (
    <section className="relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center md:bg-fixed"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1506472634167-c6776cd44d07?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHw0fHxhZXJpYWwlMjBjb2FzdGxpbmV8ZW58MHx8fHwxNzg0MDM0NjQwfDA&ixlib=rb-4.1.0&q=85')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#530e2f]/85 via-[#530e2f]/55 to-[#86233a]/40" />

      <div className="relative max-w-4xl mx-auto px-6 py-28 lg:py-36 text-center text-white">
        <span className="reveal inline-flex items-center gap-2 rounded-full bg-white/15 border border-white/25 px-4 py-1.5 text-xs font-500 uppercase tracking-[0.2em]">
          <Compass size={14} /> Laat je inspireren
        </span>
        <h2 className="reveal font-display mt-6 text-4xl sm:text-5xl lg:text-6xl font-600 leading-[1.1]">
          De mooiste verhalen
          <span className="block italic text-[#ffd7d4]">beginnen met een reis.</span>
        </h2>
        <p className="reveal mt-6 mx-auto max-w-xl text-lg text-white/85 leading-relaxed">
          Waar droom jij van? Een zonsondergang boven de oceaan, een stadstrip vol
          cultuur of een rustige plek ver van alles. Vertel het me en ik maak het
          werkelijkheid.
        </p>
        <a
          href="#contact"
          className="reveal mt-9 inline-flex items-center gap-2 rounded-full bg-white px-8 py-3.5 text-[#86233a] font-500 hover:bg-[#ffd7d4] transition-colors duration-300 shadow-[0_10px_30px_rgba(0,0,0,0.25)]"
        >
          Plan je droomreis
        </a>
      </div>
    </section>
  );
};

export default InspirationBand;
